<template>
  <div class="share-wrapper" ref="shareWrapper" @click.prevent.stop="toggleShare">
    <div class="action-item share-btn" :class="{ 'is-active': showShare }">
      <svg
        class="action-icon share-icon"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6518 4.00218C11.6518 3.0373 12.8055 2.53996 13.507 3.2024L22.4119 11.6111C22.5328 11.7252 22.6009 11.8844 22.6 12.0507C22.5991 12.217 22.5292 12.3754 22.407 12.4882L13.498 20.7134C12.7934 21.3639 11.6518 20.8642 11.6518 19.9052V16.4565C11.5254 16.4252 11.3694 16.3916 11.1865 16.3618C9.66741 16.114 6.21207 16.1026 2.44577 19.9661C2.2786 20.1376 2.02547 20.1933 1.80179 20.1077C1.57811 20.0222 1.42672 19.8118 1.41666 19.5725C1.21085 14.68 2.94125 11.6956 5.13703 9.90915C7.3006 8.14889 9.84578 7.60791 11.2094 7.43905C11.3737 7.4187 11.522 7.40361 11.6518 7.39243V4.00218Z"
          fill="currentColor"
          fill-rule="evenodd"
          clip-rule="evenodd"
        />
      </svg>
      <span>分享</span>
    </div>

    <transition name="share-fade">
      <div v-if="showShare" class="share-list" :style="shareListStyle" @click.prevent.stop>
        <div class="share-item" @click.prevent.stop="copyLink">
          <svg class="share-item-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.35321 13.1314C3.83017 14.6544 3.83017 17.1238 5.35321 18.6468C6.87625 20.1699 9.3456 20.1699 10.8686 18.6468L12.4007 17.1148C12.635 16.8804 13.0149 16.8804 13.2492 17.1148C13.4836 17.3491 13.4836 17.729 13.2492 17.9633L11.7172 19.4953C9.7255 21.487 6.49636 21.487 4.50468 19.4953C2.51301 17.5037 2.51301 14.2745 4.50468 12.2829L6.03675 10.7508C6.27106 10.5165 6.65096 10.5165 6.88527 10.7508C7.11959 10.9851 7.11959 11.365 6.88528 11.5993L5.35321 13.1314ZM10.7508 6.88527C10.5165 6.65096 10.5165 6.27106 10.7508 6.03674L12.2829 4.50468C14.2745 2.513 17.5037 2.51301 19.4953 4.50468C21.487 6.49635 21.487 9.7255 19.4953 11.7172L17.9633 13.2492C17.729 13.4835 17.3491 13.4835 17.1148 13.2492C16.8804 13.0149 16.8804 12.635 17.1148 12.4007L18.6468 10.8686C20.1699 9.3456 20.1699 6.87625 18.6468 5.35321C17.1238 3.83016 14.6544 3.83016 13.1314 5.35321L11.5993 6.88527C11.365 7.11959 10.9851 7.11959 10.7508 6.88527ZM9.21873 14.7813C8.98441 14.547 8.98441 14.1671 9.21873 13.9328L13.9328 9.21872C14.1671 8.98441 14.547 8.98441 14.7813 9.21872C15.0156 9.45304 15.0156 9.83294 14.7813 10.0673L10.0673 14.7813C9.83294 15.0156 9.45304 15.0156 9.21873 14.7813Z"
              fill="currentColor"
              fill-rule="evenodd"
              clip-rule="evenodd"
            />
          </svg>
          <span>复制链接</span>
        </div>

        <div class="share-item" @click.prevent.stop="shareWechat">
          <img class="share-item-icon" :src="wechatIcon" alt="微信" />
          <span>微信好友</span>
        </div>

        <div class="share-item" @click.prevent.stop="shareQQ">
          <img class="share-item-icon" :src="qqIcon" alt="QQ" />
          <span>QQ好友</span>
        </div>

        <div class="share-item" @click.prevent.stop="shareWeibo">
          <img class="share-item-icon" :src="weiboIcon" alt="微博" />
          <span>微博</span>
        </div>
      </div>
    </transition>

    <transition name="share-fade">
      <div v-if="showQrcode" class="qrcode-mask" @click.prevent.stop="showQrcode = false">
        <div class="qrcode-box">
          <div class="qrcode-title">{{ qrcodeTitle }}</div>
          <img class="qrcode-img" :src="qrcodeUrl" alt="二维码" />
          <div class="qrcode-tip">{{ qrcodeTip }}</div>
          <div class="qrcode-close" @click.prevent.stop="showQrcode = false">关闭</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'ShareButton',
  props: {
    newsCode: { type: [String, Number], default: '' },
    title: { type: String, default: '' }
  },
  data() {
    return {
      showShare: false,
      showQrcode: false,
      qrcodeType: 'wechat',
      shareListStyle: {},
      wechatIcon: require('../../../assets/img/share/wechat.png'),
      qqIcon: require('../../../assets/img/share/qq.png'),
      weiboIcon: require('../../../assets/img/share/weibo.png')
    }
  },
  computed: {
    shareUrl() {
      const origin = window.location.origin
      return `${origin}/zp/a/${this.newsCode}`
    },
    qrcodeUrl() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(this.shareUrl)}`
    },
    qrcodeTitle() {
      return this.qrcodeType === 'qq' ? 'QQ扫一扫分享' : '微信扫一扫分享'
    },
    qrcodeTip() {
      return this.qrcodeType === 'qq'
        ? '打开QQ，扫描二维码即可分享给好友'
        : '打开微信，扫描二维码即可分享给好友'
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    toggleShare() {
      if (this.showShare) {
        this.showShare = false
        return
      }
      const el = this.$refs.shareWrapper
      if (el) {
        const rect = el.getBoundingClientRect()
        this.shareListStyle = {
          top: (rect.bottom + 8) + 'px',
          left: (rect.left + rect.width / 2) + 'px'
        }
      }
      this.showShare = true
    },
    handleOutsideClick() {
      if (this.showShare) this.showShare = false
    },
    copyLink() {
      const url = this.shareUrl
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          Toast('链接已复制')
        }).catch(() => {
          this.fallbackCopy(url)
        })
      } else {
        this.fallbackCopy(url)
      }
      this.showShare = false
    },
    fallbackCopy(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        Toast('链接已复制')
      } catch (e) {
        Toast('复制失败，请手动复制')
      }
      document.body.removeChild(textarea)
    },
    shareWechat() {
      this.qrcodeType = 'wechat'
      this.showShare = false
      this.showQrcode = true
    },
    shareQQ() {
      this.qrcodeType = 'qq'
      this.showShare = false
      this.showQrcode = true
    },
    shareWeibo() {
      const url = encodeURIComponent(this.shareUrl)
      const title = encodeURIComponent(this.title || '分享文章')
      window.open(
        `http://service.weibo.com/share/share.php?url=${url}&title=${title}`,
        '_blank'
      )
      this.showShare = false
    }
  }
}
</script>

<style scoped>
.share-wrapper {
  position: relative;
  display: inline-flex;
}

.share-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #999;
  transition: color 0.2s;
  user-select: none;
}

.share-btn:hover,
.share-btn.is-active {
  color: #C00513;
}

.share-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  object-fit: contain;
}

.share-list {
  position: fixed;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  z-index: 9998;
  min-width: 120px;
}

.share-list::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-bottom-color: #fff;
}

.share-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 13px;
  color: #333;
  white-space: nowrap;
  transition: background 0.2s;
}

.share-item:hover {
  background: #f5f5f5;
  color: #C00513;
}

.share-item-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.share-fade-enter-active,
.share-fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.share-fade-enter,
.share-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(4px);
}

.qrcode-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.qrcode-box {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.qrcode-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.qrcode-img {
  width: 200px;
  height: 200px;
}

.qrcode-tip {
  font-size: 12px;
  color: #999;
}

.qrcode-close {
  margin-top: 4px;
  padding: 6px 24px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.qrcode-close:hover {
  background: #f5f5f5;
}
</style>
